// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"446":"7d1031e9","787":"57cd1f6f"}[chunkId] + ".chunk.js";
};